import { takeLatest } from 'redux-saga/effects';

import { API_REQ_ACTION_TYPES } from 'api/actions';

import { updateUniqueField } from './sagas';

function* watcherSaga() {
  yield takeLatest(
    [
      API_REQ_ACTION_TYPES.FIELDS.GET_BY_PROCESS_ID.START,
      API_REQ_ACTION_TYPES.FIELDS.GET_BY_PROCESS_ID.SUCCESS,
    ],
    updateUniqueField
  );
}

export default watcherSaga;
